import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch } from "react-redux";
import { clinicianLogout } from "../../../../redux/clinicianDucks";
// Constants
import { pathHomePage } from "../../../../config/constants";
// Components
import { HeaderContainer, Menu, LanguageLogoutContainer, BtnLogout } from "./styles";
import Translations from "../../../translations";
import ProjectVersion from "../../../projectVersion";

const Header = () => {
  const [redirect, setRedirect] = useState(false);

  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(clinicianLogout());
    setRedirect(true);
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}`} />;
  }

  return (
    <HeaderContainer>
      <Menu>
        <LanguageLogoutContainer>
          <Translations />
          <BtnLogout onClick={handleLogout}>{t("header.logoutButton")}</BtnLogout>
        </LanguageLogoutContainer>
      </Menu>
      <ProjectVersion />
    </HeaderContainer>
  );
};

export default Header;
